import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import ModalControls from "../../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../../defaults/Forms";
import { zusAccidentBranchDefault } from "../../../../../defaults/Items";

import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../../common/LoadingDataDiv";
import DeleteWarningModal from "../../../common/DeleteWarningModal";
import SettingsEntityModal from "../../../common/SettingsEntityModal";
import TextInput from "../../../../elements/TextInput";
import TextArea from "../../../../elements/TextArea";
import useCrud from "../../../../../hooks/useCrud";
import { Table } from "../../../../table/Table";

import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Toggler from "../../../../elements/Toggler";
import {HexColorPicker} from "react-colorful";
import NumberInput from "../../../../elements/NumberInput";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import {Modal} from "react-bootstrap";


const ZusAccidentBranch = () => {

  const dataUrl = "/zus-accident-branches";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = zusAccidentBranchDefault;
  const itemName = "Branża do składki wypadkowej ZUS";
  const itemNames = "Branże do składki wypadkowej ZUS";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Domyślna", accessor: "defaultBranch", sortable: true, searchable: true, type: "bool"},
    {label: "Aktywna", accessor: "active", sortable: true, searchable: true, type: "bool"},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.code) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }
      if (!currentItem.code) {
        let codeInput = document.getElementById("code");
        codeInput.classList.add("form-input-invalid");
        codeInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      name: currentItem.name,
      defaultBranch: currentItem.defaultBranch,
      code: currentItem.code,
      active: currentItem.active
    };

    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);

    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }


  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const response = await getItems(dataUrl);
      if (response.status === 200) {

        setLoading(false);
        setItems(response.data);

      } else if (response.status === 401 || response.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nową branżę do składki wypadkowej ZUS`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  return (
    <div id="layoutSidenav_content" className="settings-entity-page">
      <AppComponentCardHeader title="Branże wypadkowe ZUS" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <SettingsEntityModal
        show={currentFormState.showForm}
        onClose={onClose}
        title={currentFormState.formAddingDataMode ? "Nowa pozycja: Branża wypadkowa ZUS" : `Edycja: ${currentItem.name || "Branża wypadkowa ZUS"}`}
        adding={currentFormState.formAddingDataMode}
        introText="Branże wypadkowe służą do przypisania właściwej stawki ubezpieczenia wypadkowego."
        onRestore={() => { setUpdateConflict(false); restoreFormData({state}); }}
        onDelete={onDelete}
        onSubmit={onSaveItemClick}
        state={state}
        size="lg"
      >
        <form id="add-zusAccidentBranch-form" name="add-zusAccidentBranch-form" className="settings-form-content-card">
                              <div className="row form-group mb-2">
                                <div className="col-md-1 form-label">
                                  <label htmlFor="name">Nazwa *</label>
                                </div>
                                <div className="col-md-11">
                                  <TextInput propertyName="name" required={true} state={state} />
                                </div>
                              </div>

                              <div className="row form-group mb-2">
                                <div className="col-md-1 form-label">
                                  <label htmlFor="code">Kod PKD *</label>
                                </div>
                                <div className="col-md-1">
                                  <TextInput propertyName="code" required={true} state={state} />
                                </div>
                              </div>

                              <div className="row form-group mb-2">
                                <div className="col-md-1 form-label">
                                  <label htmlFor="defaultBranch">Domyślna</label>
                                </div>
                                <div className="col-md-1">
                                  <Toggler propertyName="defaultBranch" state={state} />
                                </div>
                              </div>

                              <div className="row form-group mb-2">
                                <div className="col-md-1 form-label">
                                  <label htmlFor="active">Aktywna</label>
                                </div>
                                <div className="col-md-1">
                                  <Toggler propertyName="active" state={state} />
                                </div>
                              </div>

                              <p
                                id="conflict_notification"
                                className={updateConflict ? "err_info" : "offscreen"}
                              >
                                <FontAwesomeIcon icon={faInfoCircle} />
                                &nbsp;Nie można dodać ani zmienić tego elementu, ponieważ
                                istnieje już wpis o tej nazwie i/lub skrócie
                              </p>
                            </form>
      </SettingsEntityModal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );
}

export default ZusAccidentBranch;
